<template>
  <div class="add_popup bk_none">
    <div class="begin_content">
      <img :src="formData.fields">
      <div class="begin_title">{{formData.name}}</div>
      <div class="begin_text">{{formData.remark}}</div>
    </div>
    <yd-cell-group v-for="(field,index) in fields" :key="index">
      <yd-cell-item v-if="field.field_type === 'text'">
        <span slot="left"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</span>
        <input slot="right" type="text" v-model="fieldsData[field.field_name]" :placeholder="field.remind">
      </yd-cell-item>
      <yd-cell-item v-else-if="field.field_type === 'textarea'">
        <span slot="left"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</span>
        <textarea slot="right" type="text" v-model="fieldsData[field.field_name]"
                  :placeholder="field.remind"></textarea>
      </yd-cell-item>
      <div v-else-if="field.field_type === 'radio'">
        <div class="form_tit"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</div>
        <div class="radio_cection" v-for="(radio,index) in field.field_ext" :key="index">
          <input type="radio" v-model="fieldsData[field.field_name]" :value="radio">{{radio}}
        </div>
      </div>
      <div v-else-if="field.field_type === 'checkbox'">
        <div class="form_tit"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</div>
        <div v-for="(radio,index) in field.field_ext" :key="index">
          <input type="checkbox" v-model="fieldsData[field.field_name]" :name="field.field_name" :value="radio"
          >{{radio}}
        </div>
      </div>
      <div v-else-if="field.field_type === 'select'">
        <div class="form_tit"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</div>
        <div>
          <select name="" v-model="fieldsData[field.field_name]">
            <option v-for="(select,index) in field.field_ext" :key="index" :value="select">{{select}}</option>
          </select>
        </div>
      </div>
      <div v-else-if="field.field_type === 'img'">
        <div class="form_tit"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</div>
        <div>
          <input type="file" :name="field.field_name" @change="fileUpload">
        </div>
      </div>
      <div v-else-if="field.field_type === 'date'">
        <div class="form_tit"><b style="color:red" v-if="field.is_required === '1'">* </b>{{field.field_des}}：</div>
        <div>
          <input type="date" v-model="fieldsData[field.field_name]">
        </div>
      </div>
    </yd-cell-group>
    <yd-button @click.native="tijiao">提交</yd-button>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  data () {
    return {
      params: this.$route.params,
      fieldsData: [],
      fields: [],
      formData: []
    }
  },
  methods: {
    getFields () {
      let data = {id: this.params.id}
      axios
        .post('/fair/form', data)
        .then(this.getFieldsSucc)
    },
    getFieldsSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.fields = res.data.fields
        this.formData = res.data.formModel
      }
    },
    fileUpload (event) {
      let file = event.target.files
      let reader = new FileReader()
      reader.readAsDataURL(file[0])
      let _this = this
      reader.onload = function (e) {
        let data = {
          data: e.target.result,
          name: file[0].name
        }
        axios
          .post('/fair/file-upload', data)
          .then(res => {
            res = res.data
            if (res.status) {
              _this.$dialog.toast({mes: res.msg})
              _this.fieldsData[event.target.name] = res.data.id
              _this.$emit('refreshData', 'fieldsData', _this.fieldsData)
            } else {
              _this.$dialog.toast({mes: res.msg})
            }
          })
      }
    },
    tijiao () {
      let _this = this
      let isTrue = true
      let data = {}
      this.fields.forEach(item => {
        if (item.is_required === '1' && (this.fieldsData[item.field_name] === undefined || this.fieldsData[item.field_name].length <= 0)) {
          _this.$dialog.toast({mes: item.field_des + '不能为空'})
          isTrue = false
          throw Error()
        }
        data[item.field_name] = this.fieldsData[item.field_name]
      })
      if (!isTrue) {
        return false
      }
      axios
        .post('/fair/save-form', {data: data, form_id: this.params.id})
        .then((res) => {
          res = res.data
          if (res.status) {
            _this.$dialog.toast({mes: '保存成功'})
            window.location.href = window.location.host
          } else {
            _this.$dialog.toast({mes: res.msg})
          }
        })
    }
  },
  mounted () {
    this.getFields()
  }
}
</script>

<style lang="stylus" scoped>
  .clearfix
    clear: both

  .add_popup
    background #fff
    padding 15px

  .add_popup >>>.yd-cell-item
    padding-left 0
    margin-bottom 0.45rem

  .add_popup >>>.yd-cell-box
    margin-bottom 0

  .add_popup  >>>.yd-cell-right,.add_popup  >>>.yd-cell-left,.add_popup >>>.yd-cell-item
    display block
    width 100%

  .add_popup  >>>.yd-cell-left
    margin-bottom 0.3rem

  .add_popup  >>>.yd-cell-right
    padding-right 0
    min-height 0.65rem

  .add_popup input[type="text"]
    width 100%
    display block
    height 0.65rem
    border 1px solid #dcdcdc
    border-radius 3px
    padding-left 0.27rem

  .add_popup select
    width 100%
    display block
    height 0.65rem
    border 1px solid #dcdcdc
    border-radius 3px
    padding-left 0.27rem
    -webkit-appearance menulist
    margin-bottom 0.45rem

  .add_popup textarea
    width 100%
    display block
    height 2.365rem
    border 1px solid #dcdcdc
    border-radius 3px
    padding-left 0.27rem
    padding-top 0.25rem

  .form_tit
    margin-bottom 0.3rem
    color #555
    font-size 0.28rem

  .radio_cection
    margin-bottom 0.25rem
    color #666
    font-size 0.27625rem

  .radio_cection input[type="radio"]
    margin-right 0.2rem
    width 0.35rem
    height 0.35rem
    border-radius 100%
    border 1px solid #dcdcdc
    -webkit-appearance none
    -moz-appearance none
    appearance none
    position relative

  .radio_cection input[type="radio"]:checked
    border 1px solid #1799E8

  .radio_cection input[type="radio"]:checked:after
    content ""
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    width 0.2rem
    height 0.2rem
    margin auto
    background #1799E8
    border-radius 100%
  .add_popup >>>.yd-btn
    display block
    margin 0 auto
    margin-top 0.45rem
    height auto
    padding 0.15rem 0.75rem
    font-size 0.29rem
    border-radius 3px

  .begin_content
    margin-bottom 0.45rem
    width 100%
    overflow hidden

  .begin_content img
    width 100%
    display block
    margin-bottom 0.25rem

  .begin_title
    width 100%
    overflow hidden
    font-size 0.42rem
    color #333
    text-align center
    margin-bottom 0.25rem

  .begin_text
    padding-bottom 0.25rem
    border-bottom 2px solid #53a4f4
    font-size 0.32625rem
    color #666
</style>



// WEBPACK FOOTER //
// src/views/template1/Form.vue